import(/* webpackMode: "eager", webpackExports: ["HomePageClient"] */ "/app/src/app/[locale]/page.client.tsx");
